/***
 * File name: systemModeTable.js
 *
 * Program Description:
 * This file should contain all the custom system configurations if there's any
 *
 */
const systemModeTable = []

export default systemModeTable
